export enum OperationStatusEnumFR {
	EN_VOTE = 'EN_VOTE',
	EN_FINANCEMENT = 'EN_FINANCEMENT',
	FINANCE = 'FINANCE',
	SORTIE = 'SORTIE'
}

export enum OperationStatusEnum {
	VOTE = 'VOTE',
	FUNDING = 'FUNDING',
	FUNDED = 'FUNDED',
	REFUNDED = 'REFUNDED'
}
export enum OperationRegulationsEnum {
	PSFP = 'PSFP',
	PSI = 'PSI'
}

export const getOperationStatusFromFr = (e: OperationStatusEnumFR): OperationStatusEnum => {
	switch (e) {
		case OperationStatusEnumFR.EN_VOTE:
			return OperationStatusEnum.VOTE;
		case OperationStatusEnumFR.EN_FINANCEMENT:
			return OperationStatusEnum.FUNDING;
		case OperationStatusEnumFR.FINANCE:
			return OperationStatusEnum.FUNDED;
		case OperationStatusEnumFR.SORTIE:
			return OperationStatusEnum.REFUNDED;
	}
};

export const getOperationStatusFromEn = (e: OperationStatusEnum): OperationStatusEnumFR => {
	switch (e) {
		case OperationStatusEnum.VOTE:
			return OperationStatusEnumFR.EN_VOTE;
		case OperationStatusEnum.FUNDING:
			return OperationStatusEnumFR.EN_FINANCEMENT;
		case OperationStatusEnum.FUNDED:
			return OperationStatusEnumFR.FINANCE;
		case OperationStatusEnum.REFUNDED:
			return OperationStatusEnumFR.SORTIE;
	}
};

export const getOperationStatusArrayFromFr = (
	a: OperationStatusEnumFR[]
): OperationStatusEnum[] => {
	return a.map((e) => getOperationStatusFromFr(e));
};
